import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";

import { Box, Button, IconButton, Menu, MenuItem, Switch } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import TableComponent from "../../components/TableComponent";
import {
  useGetDocumentsMutation,
  useLazyDeleteDocumentQuery,
  useUpdateDocumentMutation,
} from "../../service/ducuments";
import { CommonBody, DocumentList, Permission } from "../../types/General";
import { errorToast, successToast } from "../../helpers";
import { UPDATE_TYPES, USER_ROLES, VISA_TYPE_NAMES } from "../../utils/enums";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { isValidInput } from "../../utils/validations";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import useAuth from "../../hooks/useAuth";

const ManageDocuments = () => {
  const userData = useAuth();
  const [hidePermission, setHidePermission] = useState<Permission>();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [open, setOpen] = useState(false);

  const [documentsList] = useGetDocumentsMutation();
  const [deleteDocument] = useLazyDeleteDocumentQuery();
  const [changeStatus] = useUpdateDocumentMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<DocumentList[]>([]);
  const [page, setPage] = useState<number>(1);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "documentName",
      headerName: "Document Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image">
            <p>{row?.document_name || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "visaType",
      headerName: "Visa Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="sq_image">
            <p>{row?.visa_type ? VISA_TYPE_NAMES[row?.visa_type] : "-"}</p>
          </div>
        );
      },
    },

    {
      flex: 0.5,
      minWidth: 150,
      field: "status",
      filterable: false,
      sortable: false,
      headerName: "Status",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.is_active}
            onChange={() =>
              handleUserUpdate(row?.id, !row?.is_active, UPDATE_TYPES.BLOCK)
            }
          />
        );
      },
    },
    ...(userData?.user_role_type === USER_ROLES.ADMIN ||
    hidePermission?.can_add_edit ||
    hidePermission?.can_be_delete
      ? [
          {
            flex: 0.1,
            minWidth: 80,
            field: "action",
            headerName: "Action",
            editable: false,
            sortable: false,
            renderCell: ({ row }: GridRenderCellParams<any>) => {
              return (
                <div className="table_actions">
                  <Box>
                    <IconButton
                      aria-controls={open1 ? "basic-menu1" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open1 ? "true" : undefined}
                      onClick={(event) => handleClick1(event, row?.id)}
                    >
                      <img src="/static/images/more_icon.svg" alt="" />
                    </IconButton>
                    <Menu
                      className="setting_menu"
                      id="basic-menu1"
                      anchorEl={anchorEl1}
                      open={open1}
                      onClose={handleClose1}
                      MenuListProps={{
                        "aria-labelledby": "basic-button1",
                      }}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                          borderRadius: "8px",
                          mt: 1,
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      {userData?.user_role_type === USER_ROLES.ADMIN ||
                      hidePermission?.can_add_edit ? (
                        <MenuItem
                          onClick={() => {
                            navigate(`edit/${selectedId}`);
                          }}
                        >
                          Edit
                        </MenuItem>
                      ) : null}
                      {userData?.user_role_type === USER_ROLES.ADMIN ||
                      hidePermission?.can_be_delete ? (
                        <MenuItem
                          onClick={() => {
                            const currentDoc = rows?.find(
                              (item) => item?.id === selectedId
                            );
                            if (
                              !canProceedWithAction(
                                selectedId,
                                currentDoc?.visa_type,
                                "delete",
                                rows
                              )
                            ) {
                              errorToast(
                                "At least one active document is required per visa type."
                              );
                              return;
                            } else {
                              setAnchorEl1(null);
                              setOpen(true);
                            }
                          }}
                        >
                          Delete
                        </MenuItem>
                      ) : null}
                    </Menu>
                  </Box>
                </div>
              );
            },
          },
        ]
      : []),
  ];

  const canProceedWithAction = (
    id: number | null,
    visaType: any,
    action: "delete" | "disable",
    rows: any[]
  ) => {
    const filtered = rows.filter(
      (item) => item.visa_type === visaType && item.is_active
    );

    if (action === "delete" || action === "disable") {
      const isTargetActive = rows.find((item) => item.id === id)?.is_active;
      if (isTargetActive && filtered.length <= 1) {
        return false;
      }
    }

    return true;
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteDocument({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        successToast("Deleted successfully");
        getDocumentsList();
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleUserUpdate = async (id: number, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { is_active: status } : {}),
    };

    try {
      const currentDoc = rows.find((item) => item.id === id);

      if (type === UPDATE_TYPES.BLOCK && status === false) {
        if (!canProceedWithAction(id, currentDoc?.visa_type, "disable", rows)) {
          errorToast("At least one active document is required per visa type.");
          return;
        }
      }
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.status === 200) {
        const updatedData = rows?.map((item) => {
          if (item?.id === id) {
            return {
              ...item,
              is_active: status,
            };
          }
          return item;
        });
        setRows(updatedData);
        if (status === true) {
          successToast("Status enabled successfully");
        } else {
          successToast("Status disabled successfully");
        }
      } else {
        errorToast("Please try again");
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
    }
  };

  const getDocumentsList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 10,
        search: debouncedSearchTerm.trim(),
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await documentsList(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
        setCount(response?.data?.total_records);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getDocumentsList();
  }, [debouncedSearchTerm, page]);

  const checkPermission = () => {
    const permission = userData?.role_permission;
    if (permission?.length) {
      const foundPermission = permission?.find(
        (ele: Permission) => ele?.module === "Manage Documents"
      );

      if (foundPermission) {
        setHidePermission(foundPermission);
      } else {
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    if (userData?.user_role_type === USER_ROLES.SUBADMIN) {
      checkPermission();
    }
  }, [userData]);

  useEffect(() => {
    if (typeof hidePermission !== "undefined") {
      if (!hidePermission?.can_view) {
        navigate("/permission-denied", { replace: true });
      }
    }
  }, [hidePermission, userData]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Documents</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Documents
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                {userData?.user_role_type === USER_ROLES.ADMIN ||
                hidePermission?.can_add_edit ? (
                  <Button
                    className="btn btn_blue"
                    onClick={() => navigate("add")}
                  >
                    Add Document
                  </Button>
                ) : null}
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={rows}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </div>
        </Box>
        <ConfirmationModal
          text={"Are you sure to delete this document?"}
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={handleDelete}
        />
      </div>
    </MainContainer>
  );
};

export default ManageDocuments;
